/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FichierGridDto
 */
export interface FichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof FichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the FichierGridDto interface.
 */
export function instanceOfFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FichierGridDtoFromJSON(json: any): FichierGridDto {
    return FichierGridDtoFromJSONTyped(json, false);
}

export function FichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function FichierGridDtoToJSON(value?: FichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

